<!-- 巡检人员 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff; height: 100%; margin-top: 5px">
            <a-col :md="24" :sm="24" class="new-tree-col">
              <a-menu mode="inline" v-model="selectedKeys" @select="onSelect">
                <a-menu-item v-for="item in list" :key="item.code">
                  <span>{{ `${item.name}${$t('【{code}】', { code: item.code })}` }}</span>
                </a-menu-item>
              </a-menu>
            </a-col>
          </div>
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('名称')">
                  <a-input :placeholder="$t('请输入名称')" v-model="queryParam.searchName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
          <!-- 操作按钮区域 -->
          <div class="table-operator">
            <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-tabs v-model="activeKey" @change="onChange">
              <a-tab-pane key="1" :tab="$t('图标配置')"> </a-tab-pane>
              <a-tab-pane key="2" :tab="$t('管径渲染配置')"> </a-tab-pane>
              <a-tab-pane key="3" :tab="$t('压力渲染配置')"> </a-tab-pane>
              <!-- <a-tab-pane key="4" tab="流速渲染配置"> </a-tab-pane> -->
              <a-tab-pane key="5" :tab="$t('分级渲染配置')"> </a-tab-pane>
            </a-tabs>
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="false"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
                <a-divider type="vertical" />
                <a @click="handleCopy(record)">{{ $t('复制') }}</a>
                <a-divider type="vertical" />
                <a @click="handleStart(record)" :disabled="record.ifUsed == 1">{{ $t('启用') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </div>
        <IconConfigurationModal ref="IconConfigurationModalRef" @ok="callback"></IconConfigurationModal>
        <PipeConfigurationModal ref="PipeConfigurationModalRef" @ok="callback"></PipeConfigurationModal>
        <PressureConfigurationModal ref="PressureConfigurationModalRef" @ok="callback"></PressureConfigurationModal>
        <FlowConfigurationModal ref="FlowConfigurationModalRef" @ok="callback"></FlowConfigurationModal>
        <HierarchicalConfigurationModal
          ref="HierarchicalConfigurationModalRef"
          @ok="callback"
        ></HierarchicalConfigurationModal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction, deleteAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import IconConfigurationModal from './components/IconConfigurationModal.vue'
import PipeConfigurationModal from './components/PipeConfigurationModal.vue'
import PressureConfigurationModal from './components/PressureConfigurationModal.vue'
import FlowConfigurationModal from './components/FlowConfigurationModal.vue'
import HierarchicalConfigurationModal from './components/HierarchicalConfigurationModal.vue'
import Vue from 'vue'
import { updateGeoServerStyle } from '../module/comFunction/SLDFunction'

export default {
  name: 'RenderingConfiguration',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    IconConfigurationModal,
    PipeConfigurationModal,
    PressureConfigurationModal,
    FlowConfigurationModal,
    HierarchicalConfigurationModal,
  },
  data() {
    return {
      description: this.$t('渲染配置'),
      collapsed: false,
      url: {
        listProjectTopology: '/jeecg-gis/topology/topology/listProjectTopology',
        list: '/jeecg-gis/customizeConfigScheme/listCustomizeConfigScheme',
        delete: '/jeecg-gis/customizeConfigScheme/deleteCustomizeConfigScheme',
        useScheme: '/jeecg-gis/customizeConfigScheme/useScheme',
        getCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/getCustomizeConfigScheme',
        createCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/createCustomizeConfigScheme',
        getUsedTopology: '/jeecg-gis/topology/topology/getUsedTopology',
      },
      dictOptions: {},
      superFieldList: [],
      list: [],
      selectedKeys: [],
      currentproject: {},
      activeKey: '1',
      versionForm: {},
    }
  },
  computed: {
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => parseInt(index) + 1,
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: this.$t('备注'),
          align: 'center',
          dataIndex: 'remark',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 220,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  created() {
    this.init()
  },
  methods: {
    loadData(type) {
      // if (!this.currentproject.code) {
      //   this.$message.warning('请选择左侧项目！')
      //   return
      // }
      let params = {
        projectCode: this.currentproject.code,
        customizeConfigType: type,
        searchName: this.queryParam.searchName,
      }
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.dataSource = res.result
        }
      })
    },
    searchQuery() {
      this.onChange()
    },
    init() {
      postAction(this.url.listProjectTopology).then(res => {
        if (res.success) {
          this.list = res.result
          this.versionForm = Vue.ls.get('GIS_TOPOLOGY_DATA').topology
          this.selectedKeys = [this.versionForm.projectCode]
          this.currentproject = this.list.find(val => val.code == this.versionForm.projectCode)
          this.onChange()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onSelect(item) {
      this.currentproject = this.list.find(val => val.code == item.key)
      this.onChange()
    },
    onChange() {
      if (this.activeKey == 1) {
        this.loadData('CUSTOMIZE_CONFIG_TYPE_NODE_ICON')
      } else if (this.activeKey == 2) {
        this.loadData('CUSTOMIZE_CONFIG_TYPE_LINE_COMMON')
      } else if (this.activeKey == 3) {
        this.loadData('CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE')
      } else if (this.activeKey == 4) {
        // this.loadData('CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL');
      } else if (this.activeKey == 5) {
        this.loadData('CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL')
      }
    },
    handleAdd() {
      if (!this.currentproject.code) {
        this.$message.warning(this.$t('请选择左侧项目！'))
        return
      }
      if (this.activeKey == 1) {
        // 图标配置
        this.$refs.IconConfigurationModalRef.edit({
          customizeConfigScheme: {
            projectCode: this.currentproject.code,
            customizeType: 'CUSTOMIZE_CONFIG_TYPE_NODE_ICON',
          },
          customizeConfigDataList: [],
        })
        this.$refs.IconConfigurationModalRef.title = this.$t('新增')
      } else if (this.activeKey == 2) {
        // 管径配置
        this.$refs.PipeConfigurationModalRef.edit({
          customizeConfigScheme: {
            projectCode: this.currentproject.code,
            customizeType: 'CUSTOMIZE_CONFIG_TYPE_LINE_COMMON',
          },
          customizeConfigDataList: [],
        })
        this.$refs.PipeConfigurationModalRef.title = this.$t('新增')
      } else if (this.activeKey == 3) {
        // 压力配置
        this.$refs.PressureConfigurationModalRef.edit({
          customizeConfigScheme: {
            projectCode: this.currentproject.code,
            customizeType: 'CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE',
          },
          customizeConfigDataList: [],
        })
        this.$refs.PressureConfigurationModalRef.title = this.$t('新增')
      } else if (this.activeKey == 4) {
        // 流速配置
        // this.$refs.FlowConfigurationModalRef.edit({
        //   customizeConfigScheme: {
        //     projectCode: this.currentproject.code,
        //     customizeType: 'CUSTOMIZE_CONFIG_TYPE_LINE_COMMON',
        //   },
        //   customizeConfigDataList: [],
        // })
        // this.$refs.FlowConfigurationModalRef.title = this.$t('新增')
      } else if (this.activeKey == 5) {
        // 分级配置
        this.$refs.HierarchicalConfigurationModalRef.edit({
          customizeConfigScheme: {
            projectCode: this.currentproject.code,
            customizeType: 'CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL',
          },
          customizeConfigDataList: [],
        })
        this.$refs.HierarchicalConfigurationModalRef.title = this.$t('新增')
      }
    },
    handleStart(record) {
      let params = {
        projectCode: this.currentproject.code,
        schemeId: record.id,
      }
      getAction(this.url.useScheme, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('启用成功！'))
          this.onChange()
          Vue.ls.remove('GIS_TOPOLOGY_DATA')
          getAction(this.url.getUsedTopology).then(val => {
            if (val.success) {
              const EXPIRATION_24H = 24 * 60 * 60 * 1000 // 86400000毫秒
              Vue.ls.set('GIS_TOPOLOGY_DATA', val.result, EXPIRATION_24H)
              updateGeoServerStyle(record.customizeType)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleEdit(record) {
      getAction(this.url.getCustomizeConfigScheme, { schemeId: record.id }).then(res => {
        if (res.success) {
          console.log('编辑获取数据', this.activeKey)
          if (this.activeKey == 1) {
            this.$refs.IconConfigurationModalRef.edit(res.result)
            this.$refs.IconConfigurationModalRef.title = this.$t('编辑')
          } else if (this.activeKey == 2) {
            this.$refs.PipeConfigurationModalRef.edit(res.result)
            this.$refs.PipeConfigurationModalRef.title = this.$t('编辑')
          } else if (this.activeKey == 3) {
            this.$refs.PressureConfigurationModalRef.edit(res.result)
            this.$refs.PressureConfigurationModalRef.title = this.$t('编辑')
          } else if (this.activeKey == 4) {
            this.$refs.FlowConfigurationModalRef.edit(res.result)
            this.$refs.FlowConfigurationModalRef.title = this.$t('编辑')
          } else if (this.activeKey == 5) {
            this.$refs.HierarchicalConfigurationModalRef.edit(res.result)
            this.$refs.HierarchicalConfigurationModalRef.title = this.$t('编辑')
          }
        }
      })
    },
    handleDelete(record) {
      deleteAction(this.url.delete, { schemeId: record.id }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.onChange()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleCopy(record) {
      getAction(this.url.getCustomizeConfigScheme, { schemeId: record.id }).then(res => {
        if (res.success) {
          let params = res.result
          params.customizeConfigScheme.name = params.customizeConfigScheme.name + this.$t('(复制)')
          params.customizeConfigScheme.ifUsed = 0
          delete params.customizeConfigScheme.id
          delete params.customizeConfigScheme.createBy
          delete params.customizeConfigScheme.createTime
          delete params.customizeConfigScheme.updateBy
          delete params.customizeConfigScheme.updateTime
          params.customizeConfigDataList.map(item => {
            delete item.schemeId
            delete item.id
            delete item.createBy
            delete item.createTime
            delete item.updateBy
            delete item.updateTime
          })
          postAction(this.url.createCustomizeConfigScheme, res.result).then(val => {
            if (val.success) {
              this.$message.success(val.message)
              this.onChange()
            } else {
              this.$message.error(val.message)
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    callback(info) {
      this.onChange()
      Vue.ls.remove('GIS_TOPOLOGY_DATA')
      getAction(this.url.getUsedTopology).then(val => {
        if (val.success) {
          const EXPIRATION_24H = 24 * 60 * 60 * 1000 // 86400000毫秒
          Vue.ls.set('GIS_TOPOLOGY_DATA', val.result, EXPIRATION_24H)

          console.log('回调1', info)
          if (info != null) {
            if (info.customizeConfigScheme.id != null && info.customizeConfigScheme.ifUsed == 1) {
              console.log('更新已启用样式', info)
              // 编辑 已启用的样式 更新样式
              updateGeoServerStyle(info.customizeConfigScheme.customizeType)
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #e6f7ff !important;
}
</style>
